<div class="cards-editor-control-bar theme-dark">
  <Menu>
    <!--
    <CardsEditorLayerControlBarItem />
    <CardsEditorConfigControlBarItem />
    <CardsEditorAddChildControlBarItem />
    <CardsEditorRemoveChildControlBarItem />
    -->
    <CardsEditorPreviewControlBarItem />
  </Menu>
</div>

<style>*, *::before, *::after {
  box-sizing: border-box;
}

.cards-editor-control-bar {
  font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background: #aaaaaa;
  color: white;
  padding: 5px 0px;
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  z-index: 999;
  --f7-menu-bg-color: black;
  --f7-menu-text-color: white;
  --f7-menu-font-size: 12px;
  --f7-menu-item-height: 32px;
}</style>

<script lang="ts">import { Menu } from 'framework7-svelte';
import './CardsEditorLayerControlBarItem.svelte';
import './CardsEditorConfigControlBarItem.svelte';
import './CardsEditorAddChildControlBarItem.svelte';
import './CardsEditorRemoveChildControlBarItem.svelte';
import CardsEditorPreviewControlBarItem from './CardsEditorPreviewControlBarItem.svelte';
</script>